export const BUDGET_NAME = "budgetName";
export const VERSION_NO = "versionNo";
export const YEAR = "year";
export const NOTES = "note";
